import React, { FC, useEffect, useState } from "react";
import { Box, Switch, TextField, Typography } from "@material-ui/core";
import { useDispatch } from "react-redux";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import CloseIcon from "@material-ui/icons/Close";
import { setTicketsBundles } from "../../../redux/actions/propertyActions";



interface TicketsBoundlesProps {
  ticketsBundles: Array<number>;
}

export const TicketsBoundles: FC<TicketsBoundlesProps> = ({
  ticketsBundles,
}) => {
  const dispatch = useDispatch();
  const [state, setState] = useState({
    ticketsBundles: Array<number>(),
  });

  useEffect(() => {
    if (ticketsBundles.length < 2) {
      const defaultArr = [2 ,  5 ];
      setState({ ticketsBundles: defaultArr });
      dispatch(
        setTicketsBundles({
          bundleTickets: defaultArr,
        })
      );
    } else {
      setState({ ticketsBundles });
    }
  }, [ticketsBundles]);

  const addItem = () => {
    const ticketsAmount =
      state.ticketsBundles[state.ticketsBundles.length - 1]+ 5;
    const ticketsBundlesArrCopy = [...state.ticketsBundles];
    const item= ticketsAmount;
    ticketsBundlesArrCopy.push(item);
    dispatch(
      setTicketsBundles({
        bundleTickets: ticketsBundlesArrCopy,
      })
    );
    setState((state) => ({
      ...state,
      ticketsBundles: ticketsBundlesArrCopy,
    }));
  };

  const handleDeleteItem = (index: number) => () => {
    const ticketsBundlesArrCopy = [
      ...state.ticketsBundles.splice(0, index),
      ...state.ticketsBundles.splice(index + 1),
    ];
    if (ticketsBundlesArrCopy.length === 0) {
      dispatch(
        setTicketsBundles({
          bundleTickets: ticketsBundlesArrCopy,
        })
      );
      setState((state) => ({
        ticketsBundles: ticketsBundlesArrCopy,
        isActive: false,
      }));
      return;
    }
    dispatch(
      setTicketsBundles({
        bundleTickets: ticketsBundlesArrCopy,
      })
    );
    setState((state) => ({
      ...state,
      bundleTickets: ticketsBundlesArrCopy,
    }));
  };

  const handleTickets = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    index: number
  ) => {
    if (parseInt(e.currentTarget.value) < 1) {
      return;
    }

    const bundlesArray = [...state.ticketsBundles];
    bundlesArray[index] = parseInt(e.currentTarget.value);
    dispatch(
      setTicketsBundles({
        bundleTickets: bundlesArray,
      })
    );
    setState({ ...state, ticketsBundles: bundlesArray });
  };
  return (
    <Box>
      <Box display="flex" alignItems="center">
        <Typography variant="h6">Status</Typography>
      </Box>
      <>
        {state.ticketsBundles.map((item, i) => {
          return (
            <Box
              display="block"
              className="base-color"
              fontFamily="SF UI Display Light"
              key={i}
            >
              <Box display="flex" alignItems="center">
                <Box paddingRight="1em" whiteSpace="nowrap">
                  Tickets
                </Box>
                <Box>
                  <Box marginBottom="0.6em" marginRight="0.6em">
                    <TextField
                      type="number"
                      label="count"
                      className="discount-field"
                      value={item}
                      onChange={(e) => handleTickets(e, i)}
                      defaultValue={1}
                      required
                    />
                  </Box>
                  {!item && (
                    <Box marginTop="2em" marginLeft="1em">
                      <div className="common-error">Required</div>
                    </Box>
                  )}
                  {i !== 0 &&
                    item <=
                      state.ticketsBundles[i - 1] && (
                      <Box marginTop="2em" marginLeft="1em">
                        <div className="common-error">
                          Should be more than previous value
                        </div>
                      </Box>
                    )}
                  {item > 1000 && (
                    <Box marginTop="2em" marginLeft="1em">
                      <div className="common-error">
                        Should be less than 1000
                      </div>
                    </Box>
                  )}
                </Box>
                <CloseIcon
                  className="remove-discount"
                  onClick={handleDeleteItem(i)}
                />
              </Box>
            </Box>
          );
        })}
        {state.ticketsBundles.length < 2 && (
          <Box marginTop="2em">
            <div className="common-error">
              Tickets bundles amount shouldn't be less then 2
            </div>
          </Box>
        )}
        <AddCircleIcon onClick={addItem} className="add-discount" />
      </>
    </Box>
  );
};
